<template>
  <div id="avantage">
    <section class="section section-lg pt-lg-0 mt--200">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12">
            <div class="row row-grid">
              <div
                class="col-lg-4"
                data-aos="fade-right"
                data-aos-duration="1000"
              >
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-bulb-61"
                    type="primary"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-primary text-uppercase">
                    <!-- Communication créative -->
                    Qui sommes-nous ?
                  </h6>
                  <p class="description mt-3">
                    Panneau Mobile est une régie publicitaire spécialisée dans le marketing de proximité au Bénin.
                    Nous aidons les marques à concevoir et déployer des campagnes terrain puissantes afin de toucher 
                    leurs audiences là où elles vivent, circulent et consomment.
                  </p>
                  <!-- <br /> -->

                  <!--                                    <div>-->
                  <!--                                        <badge type="primary" rounded>design</badge>-->
                  <!--                                        <badge type="primary" rounded>system</badge>-->
                  <!--                                        <badge type="primary" rounded>creative</badge>-->
                  <!--                                    </div>-->
                  <!--                                    <base-button tag="a" href="#" type="primary" class="mt-4">-->
                  <!--                                        Learn more-->
                  <!--                                    </base-button>-->
                </card>
              </div>

              <div class="col-lg-4" data-aos="fade-up" data-aos-duration="1300">
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-palette"
                    type="success"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-success text-uppercase">
                    <!-- Communication de proximité -->
                    Notre approche
                  </h6>
                  <p class="description mt-3">
                    Nous ne nous contentons pas de diffuser des messages publicitaires.
                    Nous créons de la présence réelle dans l’espace public.

                    Nos dispositifs de communication vont directement à la rencontre des publics dans les rues, les quartiers, les axes stratégiques et les lieux de forte fréquentation.
                  </p>
                  <!-- <div>
                  <badge type="success" rounded>business</badge>
                  <badge type="success" rounded>vision</badge>
                  <badge type="success" rounded>success</badge>
                  </div>
                  <base-button tag="a" href="#" type="success" class="mt-4">
                  Learn more
                  </base-button> -->
                </card>
              </div>

              <div
                class="col-lg-4"
                data-aos="fade-left"
                data-aos-duration="1500"
              >
                <card class="border-0" hover shadow body-classes="py-5">
                  <icon
                    name="ni ni-user-run"
                    type="warning"
                    rounded
                    class="mb-4"
                  >
                  </icon>
                  <h6 class="text-warning text-uppercase">
                    <!-- Communication sur mesure -->
                    Notre mission
                  </h6>
                  <p class="description mt-3">
                    Réinventer la communication de proximité en Afrique en rendant la publicité plus visible, plus humaine et plus efficace.

                    Nous permettons aux entreprises d’être présentes partout où se trouvent leurs clients, à travers des solutions terrain accessibles et impactantes.

                    Parce qu’une bonne campagne ne se limite pas à être vue…
                    elle doit être vécue.                  
                  </p>
              
                  <!--                                    <div>-->
                  <!--                                        <badge type="warning" rounded>marketing</badge>-->
                  <!--                                        <badge type="warning" rounded>product</badge>-->
                  <!--                                        <badge type="warning" rounded>launch</badge>-->
                  <!--                                    </div>-->
                  <!--                                    <base-button tag="a" href="#" type="warning" class="mt-4">-->
                  <!--                                        Learn more-->
                  <!--                                    </base-button>-->
                </card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "home",
  components: {},
};
</script>
<style></style>
